import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { GrupoModulo } from "./GrupoModulo";
import { useBuscadorGlobalStyles } from "./styles/BuscadorGlobalStyles";
import { List, ListSubheader } from "@mui/material";

const RecentSearches = ({
  recientes,
  onItemClick,
  onEliminarItem,
  onLimpiarTodos,
  labels = {},
}) => {
  const classes = useBuscadorGlobalStyles();

  if (!recientes || recientes.length === 0) {
    return null;
  }

  // ── Agrupar por semCode ───────────────────────────────────────────────────
  const gruposMap = {};
  recientes.forEach((item) => {
    const semCode = item.semCode || "sin-modulo";
    if (!gruposMap[semCode]) {
      gruposMap[semCode] = {
        nombreModulo: item.tituloModulo || item.semCode || "Otros",
        icono: item.icono,
        semCode,
        items: [],
      };
    }
    gruposMap[semCode].items.push(item);
  });

  const grupos = Object.values(gruposMap);
  return (
    <>
      <Box className={classes.grupoModulo}>
        <List
          className={classes.listaResultados}
          disablePadding
          subheader={
            <ListSubheader
              component="div"
              sx={{
                fontWeight: 600,
                fontSize: "0.75rem",
                textTransform: "uppercase",
                letterSpacing: "0.8px",
                lineHeight: "40px",
              }}
            >
              {labels.Et_Recientes}
            </ListSubheader>
          }
        >
          {grupos.map((grupo) => (
            <GrupoModulo
              key={grupo.semCode}
              grupo={grupo}
              onItemClick={onItemClick}
              mostrarIconoHistoria
              onEliminarItem={onEliminarItem}
            />
          ))}
        </List>
      </Box>
    </>
  );
};

export default RecentSearches;
